import {
    styled,
    Box,
    Paper,
    IconButton,
    TextField,
    Select,
    Grid,
} from '../../../../base';

export const StyledFormContainer = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%', // Make form take full height
}));

export const StyledTopControlsContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1.5),
    paddingInlineStart: theme.spacing(3),
}));

export const StyledStepsListContainer = styled(Box)(({ theme }) => ({
    flexGrow: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: '600px',
    paddingInlineEnd: theme.spacing(1),

    // Add custom scrollbar styles if needed
    // '&::-webkit-scrollbar': {
    //   width: '8px',
    // },
    // '&::-webkit-scrollbar-track': {
    //   boxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
    // },
    // '&::-webkit-scrollbar-thumb': {
    //   backgroundColor: theme.palette.grey[400],
    //   outline: '1px solid slategrey'
    // }
}));

export const StyledAddStepEndContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    paddingTop: theme.spacing(1),
}));

export const StyledFormActionsContainer = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(3),
    display: 'flex',
    justifyContent: 'flex-end',
}));

// --- SortableStep Styles ---

export const StyledSortableStepWrapper = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    position: 'relative',
}));

export const StyledStepPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    position: 'relative', // Ensure content is above potential add button visually
    zIndex: 1,
    backgroundColor: theme.palette.background.paper, // Ensure background covers elements below
}));

export const StyledDragHandle = styled(Box)(() => ({
    cursor: 'grab',
    display: 'flex',
    alignItems: 'center',
}));

export const StyledPlaceholderBox = styled(Box)(({ theme }) => ({
    //width: 24,
    //height: 24,
    // Use width/height like below or specific spacing based on DragHandle size
    width: theme.spacing(3), // Adjust based on DragIndicatorIcon size + padding
    height: theme.spacing(3),
}));

export const StyledStepFieldsGrid = styled(Grid)(() => ({
    flexGrow: 1,
    alignItems: 'flex-start',
}));

export const StyledStepNameField = styled(TextField)(() => ({
    width: '30%',
}));

export const StyledStepOwnerSelect = styled(Select)(() => ({
    width: '30%',
}));

export const StyledStepOwnerField = styled(TextField)(() => ({
    width: '30%',
}));

export const StyledInterviewersField = styled(TextField)(() => ({
    width: '40%',
}));

export const StyledStepActionPlaceholder = styled(Box)(({ theme }) => ({
    // width: 40
    width: theme.spacing(5), // Adjust based on IconButton size + padding
}));

export const StyledAddStepButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    bottom: -14, // Position between steps
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 2, // Above the step below
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    '&:hover': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
    },
}));

export const StyledPageHeader = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    paddingBottom: theme.spacing(2),
}));
